import CheckGreen from "check-green.svg";
import cn from "classnames";
import Select from "components/shared/select";
import { ending } from "helpers/i18n";
import Tooltip from "rc-tooltip";
import React from "react";
import InputMask from "react-input-mask";
import { components } from "react-select";
import { get as partyLookups } from "sources/partyLookup";

const Option = (props: any) => {
    const { name, inn } = props.data.option;
    return (
        <components.Option {...props}>
            {name} <small className="text-muted">ИНН: {inn}</small>
        </components.Option>
    );
};

const ValueContainer = (props: any) => {
    const { children, getValue, hasValue } = props;
    if (!hasValue) {
        return <components.ValueContainer {...props} />;
    }
    const { name, inn } = getValue()[0]?.option ?? {};

    return (
        <components.ValueContainer {...props}>
            {!props.selectProps.inputValue && (
                <components.SingleValue {...props}>
                    {name} <small className="text-muted">ИНН: {inn}</small>
                </components.SingleValue>
            )}
            {children[children.length - 1]}
        </components.ValueContainer>
    );
};

const customStyles = {
    container: (styles: {}) => ({
        ...styles,
        width: "100%",
    }),
    control: (styles: {}) => ({
        ...styles,
        border: "none",
        borderRadius: "30px",
        height: "42px",
        padding: "0 12px",
        lineHeight: "52px",
        backgroundColor: "#f1f1f1",
        minHeight: "26px",
        fontSize: "14px",
    }),
    indicatorsContainer: (styles: {}) => ({ ...styles, height: "42px" }),
    placeholder: (styles: {}) => ({
        ...styles,
        lineHeight: "18px",
        maxWidth: "calc(100% - 16px)",
        whiteSpace: "nowrap",
    }),
};

export function validateEmail(email: string) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
}

export function validateInn(inn: string) {
    const regex = /^[0-9]{10,12}$/;
    return regex.test(inn);
}

export function Step1CompanyInfo({
    state,
    setState,
    manual,
    setManual,
    selectValue,
    handleSelect,
    showEmail = true,
}: any) {
    const NoOptionsMessage = (data: any) => {
        if (data.selectProps.inputValue.length < 3) {
            const remainingChars = 3 - data.selectProps.inputValue.length;
            return (
                <div className="text-center py-2">
                    <small className="react-select-no-option">
                        Пожалуйста, введите ещё хотя бы {remainingChars} символ{ending(remainingChars, "", "a", "ов")}
                    </small>
                </div>
            );
        } else {
            return (
                <div className="text-center small text-muted py-2">
                    Организация не найдена, перепроверьте данные или
                    <span
                        className="link pl-1"
                        onClick={() => {
                            setManual(true);
                            setState({ ...state, name: data.selectProps.inputValue });
                        }}
                    >
                        введите данные вручную
                    </span>
                </div>
            );
        }
    };

    return (
        <>
            {manual ? (
                <>
                    <div
                        className={cn("r-form__group", {
                            "r-form__group--full": state.name.length > 0,
                        })}
                    >
                        <div>
                            <label htmlFor="name" className="r-form__label">
                                Название компании{" "}
                                <Tooltip overlay="Нужно чтобы создать аккаунт" placement="top">
                                    <i className="icon-uEA69-question-circle" />
                                </Tooltip>
                                <span className="ml-3 link float-right" onClick={() => setManual(false)}>
                                    Найти компанию по названию или ИНН
                                </span>
                            </label>
                            <input
                                required
                                className="r-form__input"
                                value={state.name}
                                id="name"
                                autoComplete="off"
                                name="name"
                                maxLength={100}
                                onChange={(e) => setState({ ...state, name: e.target.value })}
                                placeholder="Как называется ваша компания?"
                            />
                        </div>
                        <div className="r-form__after-icon">{state.name.length > 0 && <CheckGreen />}</div>
                    </div>
                    <div
                        className={cn("r-form__group", {
                            "r-form__group--full": validateInn(state.inn),
                        })}
                    >
                        <div>
                            <label htmlFor="inn" className="r-form__label">
                                ИНН
                            </label>
                            <InputMask
                                mask={state.inn.length < 10 ? "9999999999" : "999999999999"}
                                maskPlaceholder="_"
                                required
                                className="r-form__input"
                                value={state.inn}
                                id="inn"
                                name="inn"
                                onChange={(e: any) => setState({ ...state, inn: e.target.value.replace(/_/g, "") })}
                                placeholder="Введите ИНН компании"
                            />
                        </div>
                        <div className="r-form__after-icon">{validateInn(state.inn) && <CheckGreen />}</div>
                    </div>
                </>
            ) : (
                <div className="r-form__group">
                    <div>
                        <label className="r-form__label">
                            Название компании{" "}
                            <Tooltip overlay="Нужно чтобы создать аккаунт" placement="top">
                                <i className="icon-uEA69-question-circle" />
                            </Tooltip>
                        </label>
                        <Select
                            {...{
                                label: "Название или ИНН",
                                value: selectValue,
                                placeholder: "Начните вводить название или ИНН",
                                inputProps: { name: "nameOrInn" },
                                url: partyLookups,
                                propName: "name",
                                menuPortalTarget: document.body,
                                idKey: "inn",
                                onChange: handleSelect,
                                styles: customStyles,
                                minimumInputLength: 3,
                                components: { NoOptionsMessage, Option, ValueContainer },
                                filterOption: (option: { label: string; value: string }, search: string) => {
                                    if (!option.label) {
                                        return false;
                                    } else {
                                        return search
                                            .toLowerCase()
                                            .split(" ")
                                            .every(
                                                (item) =>
                                                    option.label.toLowerCase().indexOf(item) > -1 ||
                                                    option.value.toLowerCase().indexOf(item) > -1,
                                            );
                                    }
                                },
                            }}
                        />
                    </div>
                </div>
            )}
            {showEmail && (
                <div
                    className={cn("r-form__group", {
                        "r-form__group--full": validateEmail(state.email),
                    })}
                >
                    <div>
                        <label htmlFor="email" className="r-form__label">
                            Эл. почта{" "}
                            <Tooltip
                                overlay="Почта для входа и важных уведомлений. Без рассылок и спама"
                                placement="top"
                            >
                                <i className="icon-uEA69-question-circle" />
                            </Tooltip>
                        </label>
                        <input
                            required
                            className="r-form__input"
                            type="email"
                            id="email"
                            name="email"
                            autoComplete="off"
                            value={state.email}
                            onChange={(e) => setState({ ...state, email: e.target.value })}
                            placeholder="Введите электронную почту"
                        />
                    </div>
                    <div className="r-form__after-icon">{validateEmail(state.email) && <CheckGreen />}</div>
                </div>
            )}
        </>
    );
}
